/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-09T15:13:19.203
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listDepositContractTemplate,
	listDepositContractTemplateInit,
	listDepositContractTemplateByAuthorizations,
	deleteDepositContractTemplate
	
} from '@api/storagemanage/DepositContractTemplate';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listDepositContractTemplate({
			state
		}) {
			return new Promise((resolve, reject) => {
				listDepositContractTemplate(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listDepositContractTemplateByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listDepositContractTemplateByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listDepositContractTemplateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listDepositContractTemplateInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
                        state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteDepositContractTemplate({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteDepositContractTemplate({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
